/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { markEnum } from "igniteui-react-core";
export var SuffixShiftType = /*@__PURE__*/ (function (SuffixShiftType) {
    SuffixShiftType[SuffixShiftType["Line"] = 0] = "Line";
    SuffixShiftType[SuffixShiftType["Box"] = 1] = "Box";
    SuffixShiftType[SuffixShiftType["Border"] = 2] = "Border";
    return SuffixShiftType;
})({});
/**
 * @hidden
 */
export var SuffixShiftType_$type = /*@__PURE__*/ markEnum('SuffixShiftType', 'Line,0|Box,1|Border,2');
//# sourceMappingURL=SuffixShiftType.js.map
